module.exports = __webpack_public_path__ + "img/36.265e458d.svg";